/**
 * 나눔터 공유 payload 의 source_data.versions.
 * 라이브러리 가족과 같은 스키마를 URL만 복사한다. 없는 칸은 만들지 않는다.
 */

import { familyVersions, normalizeFamilyVersion, parseOutline } from './libraryFamily';

const VERSION_KEYS = ['text', 'image'];

const pickSlot = (slot, mode) => {
  const normalized = normalizeFamilyVersion(slot);
  if (!normalized) return null;
  const next = {
    file_urls: normalized.file_urls || {},
    file_url: normalized.file_url || '',
    page_count: normalized.page_count || 0,
    updated_at: normalized.updated_at || '',
  };
  if (normalized.filename) next.filename = normalized.filename;
  if (mode === 'text' && normalized.outline) next.outline = normalized.outline;
  if (mode === 'text' && normalized.outline_ref) next.outline_ref = normalized.outline_ref;
  // 텍스트 칸의 학생용 쪽 이미지도 함께 보낸다. 없으면 수신자 상세가 개요를 캔버스로 다시 그려
  // 카드 썸네일과 미리보기 모양이 달라진다(시드 학습지에서 고친 것과 같은 문제).
  if (normalized.page_urls?.length) next.page_urls = normalized.page_urls;
  return next;
};

export const snapshotVersionsForShare = (item) => {
  if (!item || (item.content_type !== 'ppt' && item.content_type !== 'worksheet')) {
    return undefined;
  }
  const versions = familyVersions(item);
  const snapshot = {};
  VERSION_KEYS.forEach((mode) => {
    const slot = pickSlot(versions[mode], mode);
    if (slot) snapshot[mode] = slot;
  });
  return Object.keys(snapshot).length ? snapshot : undefined;
};

const inferContentType = (sourceData, contentType) => {
  if (contentType === 'ppt' || contentType === 'worksheet' || contentType === 'image' || contentType === 'other') {
    return contentType;
  }
  const category = sourceData?.category;
  if (category === 'ppt_maker') return 'ppt';
  if (category === 'worksheet_gen') return 'worksheet';
  if (category === 'image_generation') return 'image';
  return '';
};

export const buildLibraryShareSourceData = (item) => {
  if (!item) return {};
  if (item.content_type === 'other') {
    return {
      artifactId: item.artifact_id,
      format: item.artifact_format,
      filename: item.filename,
      mimeType: item.mime_type,
      sizeBytes: item.size_bytes,
    };
  }
  const versions = snapshotVersionsForShare(item);
  return {
    outline: parseOutline(item.outline) || parseOutline(item.versions?.text?.outline) || null,
    previews: item.preview_urls || [],
    downloadUrl: item.download_url || null,
    ...(versions ? { versions } : {}),
  };
};

export const attachShareSourceVersions = (sourceData, extras = {}) => {
  const data = { ...(sourceData || {}) };
  const contentType = inferContentType(data, extras.contentType);
  if (contentType === 'other' || contentType === 'image') {
    delete data.versions;
    return data;
  }
  if (contentType !== 'ppt' && contentType !== 'worksheet') {
    return data;
  }
  const explicit = {};
  VERSION_KEYS.forEach((mode) => {
    const slot = pickSlot(data.versions?.[mode], mode);
    if (slot) explicit[mode] = slot;
  });
  if (Object.keys(explicit).length) {
    data.versions = explicit;
    return data;
  }
  const inferred = snapshotVersionsForShare({
    content_type: contentType,
    outline: data.outline,
    preview_urls: data.previews || data.preview_urls,
    download_url: extras.downloadUrl || data.downloadUrl || data.download_url,
    filename: data.filename || extras.filename,
    thumbnail_url: extras.thumbnailUrl,
  });
  if (inferred) data.versions = inferred;
  else delete data.versions;
  return data;
};
